// Define server URL's
const apiUrl = 'https://api.flug-claim.de';
// const apiUrl = 'http://127.0.0.1:8055';

module.exports = {
	apiUrl,
};
